import { IUserAnalyticsPreset } from '@/pages/Users/users.types.ts'

const generateEmptyPreset = (prevPresets: IUserAnalyticsPreset[]): IUserAnalyticsPreset => {
  const presetName = 'Пользовательский'
  let presetIndex = 1

  for (const preset of prevPresets) {
    if (preset.title.includes(presetName)) {
      const presetNumber = preset.title.slice(presetName.length + 1).trim()
      if (presetNumber && Number.isInteger(+presetNumber)) {
        presetIndex = +presetNumber + 1
      }
    }
  }

  return {
    id: crypto ? crypto.randomUUID() : (Math.random() * Math.random()).toFixed(10),
    parameters: [],
    title: `${presetName} ${presetIndex}`,
  }
}

const analyticsUtils = { generateEmptyPreset }
export default analyticsUtils
